import {PayloadAction, createSlice} from '@reduxjs/toolkit';

import {marketT} from '@/lib/types/market.types';

type MARKET_STATE = {
  markets: marketT[];
  isLoading?: boolean;
  error?: string;
};

const MARKET_INITIAL_STATE: MARKET_STATE = {
  markets: [],
  isLoading: false,
};

const marketSlice = createSlice({
  name: 'market',
  initialState: MARKET_INITIAL_STATE,
  reducers: {
    MARKET_UPDATE: (
      state,
      action: PayloadAction<{
        data?: Partial<MARKET_STATE>;
        prop?: keyof MARKET_STATE;
        value?: any;
      }>
    ) => {
      if (action.payload.data) {
        Object.entries(action.payload.data).forEach(([key, value]) => {
          if (key in state) {
            (state as any)[key] = value;
          }
        });
        return state;
      }

      if (action.payload.prop && action.payload.value !== undefined) {
        const prop = action.payload.prop;

        // Narrow the assignment to only properties that exist on the state
        if (prop in state) {
          (state as any)[prop] = action.payload.value;
        }
      }

      return state;
    },
  },
});

const {MARKET_UPDATE} = marketSlice.actions;

export {MARKET_UPDATE, MARKET_INITIAL_STATE, marketSlice};
